<template>
    <div class="loader-wrapper">
        <div class="loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div class="loader-text" v-html="loader_text"></div>
    </div>
</template>

<script>
  export default {
    name: 'Loader',
    props: ['text'],
    data: function () {
      return {
        'loader_text': this.$props.text ? this.$props.text : 'Loading',
      };
    },
    methods: {
      'set_loader_text': function (t) {
        this.$data.loader_text = t;
      },
    }
  }
</script>

<style scoped>

    .loader-wrapper {
        top: 50%;
        left: 0;
        position: fixed;
        margin-top: -150px;
        width: 100%;
    }

    .loader-text {
        padding: 1rem;
        text-align: center;
        font-size: 1.2rem;
    }

    .loader {
        width: 212px;
        height: 212px;
        margin: 0 auto;
        position: relative;
    }

    .loader > * {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .loader > *:nth-child(1) {
        background-image: url('./../assets/img/loader/1.png');
        animation: spin 2.5s linear infinite;
    }

    .loader > *:nth-child(2) {
        background-image: url('./../assets/img/loader/2.png');
        animation: spin-r 1.5s linear infinite;
    }

    .loader > *:nth-child(3) {
        background-image: url('./../assets/img/loader/3.png');
        animation: spin 2.25s linear infinite;
    }

    .loader > *:nth-child(4) {
        background-image: url('./../assets/img/loader/4.png');
        animation: spin-r 2s linear infinite;
    }

    .loader > *:nth-child(5) {
        background-image: url('./../assets/img/loader/5.png');
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    @keyframes spin-r {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(-360deg); }
    }

</style>
